import { render, staticRenderFns } from "./AdminBasePage.vue?vue&type=template&id=b6521bf4"
import script from "./AdminBasePage.vue?vue&type=script&lang=js"
export * from "./AdminBasePage.vue?vue&type=script&lang=js"
import style0 from "./AdminBasePage.vue?vue&type=style&index=0&id=b6521bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports